import { InputAdornment } from "@material-ui/core";
import { FormEvent, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { useHistory, useParams } from "react-router-dom";
import Button from "../../../../components/Button";
import Input from "../../../../components/Input";
import InputSelect from "../../../../components/Input-select";
import Spinner from "../../../../components/Spinner";
import Title from "../../../../components/Title";
import { toastError } from "../../../../components/Toast";
import useAuthData from "../../../../hook/useAppData";
import { IconLeftArrowVersion2 } from "../../../../icons";
import { DTOGetTax, taxDataDTOPresumed, taxDataDTOSimple } from "../../dto/taxes.dto";
import { IDTOPresumedReturn, ISimpleNational, ITaxData } from "../../model";
import { getTaxesPresumedById, getTaxesSimpleById, postTaxesPresumed, postTaxesSimple, putTaxesPresumed, putTaxesSimple } from "../../service";

export default function FormTax() {
  const { token } = useAuthData();
  const [taxData, setTaxData] = useState<ITaxData>();
  const [needSpinner, setNeedSpinner] = useState(false);
  const history = useHistory();
  const params: { id?: string } = useParams();
  const simpleIncludesInPath = history.location.pathname?.includes("simple");
  const [simpleOrPresumed, setSimpleOrPresumed] = useState<"simple" | "presumed">(simpleIncludesInPath ? "simple" : "presumed");
  const [selectedDefault, setSelectedDefault] = useState<number>(simpleIncludesInPath ? 1 : 2);
  const [postOrUpdate, setPostOrUpdate] = useState<"create" | "update">("create");

  useEffect(() => {
    if (!params?.id) setTaxData({ ...taxData, taxesDataItens: { ...taxData?.taxesDataItens, system: 0 } });
    else {
      setNeedSpinner(true);
      getValuesOfTax();
      setPostOrUpdate("update");
    }
  }, []);

  async function getValuesOfTax() {
    const values =
      simpleOrPresumed === "simple" ? await getTaxesSimpleById({ id: params?.id, token }) : await getTaxesPresumedById({ id: params?.id, token });
    const newValue = DTOGetTax(values);
    setTaxData(newValue);

    setTimeout(() => setNeedSpinner(false), 1000);
  }

  function submitForm(event: FormEvent) {
    event.preventDefault();
    if (!taxData?.name) return toastError("Nome do Perfil é Obrigatório");
    simpleOrPresumed === "presumed" ? submitPresumed() : submitSimple();
  }

  async function submitPresumed() {
    const objForRequest = changeUndefinedForZero<IDTOPresumedReturn>(taxDataDTOPresumed(taxData));
    const res: { ok: boolean } =
      postOrUpdate === "create"
        ? await postTaxesPresumed({ token, body: objForRequest })
        : await putTaxesPresumed({ token, body: objForRequest, id: +params?.id });
    verefyResponseOfSubmit(res);
  }

  async function submitSimple() {
    const objForRequest = changeUndefinedForZero<ISimpleNational>(taxDataDTOSimple(taxData));
    const res: { ok: boolean } =
      postOrUpdate === "create"
        ? await postTaxesSimple({ token, body: objForRequest })
        : await putTaxesSimple({ token, body: objForRequest, id: +params?.id });
    verefyResponseOfSubmit(res);
  }

  function verefyResponseOfSubmit({ ok }: { ok: boolean }) {
    if (!ok) return toastError(`Não foi possível ${postOrUpdate === "create" ? "salvar" : "editar"} o imposto ${taxData?.name}`);
    return exitForm();
  }

  function changeUndefinedForZero<T>(taxes): T {
    let newObj = {};
    for (let tax in taxes) {
      if (!taxes[tax]) newObj[tax] = 0;
      else newObj[tax] = taxes[tax];
    }
    return newObj as T;
  }

  function verefyIfIsNumber(value) {
    const regex = /^[\d,.?!]+$/;
    if (regex.test(value)) return true;
  }

  function verefyLengthOfValue(value) {
    if (value.includes(",") || value.includes(".")) {
      if (value.length > 5) return true;
    } else if (value.length > 3) return true;
  }

  function updateValue({ name, value }: { name: string; value: any }) {
    if (!value)
      setTaxData({
        ...taxData,
        taxesDataItens: {
          ...taxData?.taxesDataItens,
          [`${name}`]: value,
        },
      });
    if (!verefyIfIsNumber(value)) return;
    if (verefyLengthOfValue(value)) return;
    setTaxData({
      ...taxData,
      taxesDataItens: {
        ...taxData?.taxesDataItens,
        [`${name}`]: value,
      },
    });
  }

  const options = {
    1: handleSimpleNational,
    2: handlePresumedProfit,
  };

  function handleChangeDefaultOption(idSelected: number) {
    options[idSelected]();
  }

  function handlePresumedProfit() {
    setSimpleOrPresumed("presumed");
  }

  function handleSimpleNational() {
    setSimpleOrPresumed("simple");
  }

  function exitForm() {
    history.push("/taxes");
  }

  return (
    <>
      <Spinner status={needSpinner}>
        <Toaster />
        <div className="container">
          <Title
            title={
              <div className="flex items-center">
                <span onClick={exitForm} className="cursor-pointer mr-2">
                  <span>{IconLeftArrowVersion2}</span>
                </span>
                <span>{postOrUpdate === "create" ? "Cadastro de Imposto" : `Atualizar Imposto ${taxData?.name || ""}`}</span>
              </div>
            }
          />
          <div className="w-full h-auto bg-white rounded-xl flex p-4 gap-3 mb-3">
            <Input
              className="w-20"
              name="profile"
              label={"Nome do Perfil"}
              placeholder={"Digite o nome do imposto"}
              value={taxData?.name}
              setValue={(e) => setTaxData({ ...taxData, name: e.target.value })}
              required={true}
              autoFocus
            />
          </div>
          <form onSubmit={submitForm}>
            <div className="flex flex-col w-full m-auto min-h-60vh rounded-md bg-white shadow">
              <div className="w-full flex-col mb-5">
                <div className="w-full flex my-5">
                  <Input
                    value={taxData?.taxesDataItens?.fgts}
                    setValue={(e) => updateValue(e.target)}
                    name="fgts"
                    label="FGTS (%)"
                    placeholder="Digite o FGTS"
                    // required={true}
                    type="number"
                    // maxLength={3}
                  />
                  <Input
                    value={taxData?.taxesDataItens?.inss}
                    setValue={(e) => updateValue(e.target)}
                    name="inss"
                    label="INSS (%)"
                    placeholder="INSS"
                    type="number"

                    // required={true}
                  />

                  {/* <Input
                    value={taxData?.taxesDataItens?.thirdVacation}
                    setValue={(e) => updateValue(e.target)}
                    name="thirdVacation"
                    label="1/3 sobre Férias (%)"
                    placeholder="1/3 sobre Férias"
                    // required={true}
                    type="number"
                    maxLength={2}
                  /> */}
                </div>
                <div className="w-full flex mb-5">
                  <Input
                    value={taxData?.taxesDataItens?.thirteenth}
                    setValue={(e) => updateValue(e.target)}
                    name="thirteenth"
                    label="13º Salário (%)"
                    placeholder="13º Salário"
                    // required={true}
                    type="number"
                  />
                  <Input
                    value={taxData?.taxesDataItens?.vacation}
                    setValue={(e) => updateValue(e.target)}
                    name="vacation"
                    label="Férias (%)"
                    placeholder="Digite a porcentagem de Férias"
                    // required={true}
                    type="number"
                  />
                  {/* <Input
                    value={taxData?.taxesDataItens?.monthlyProvision}
                    setValue={(e) => updateValue(e.target)}
                    name="monthlyProvision"
                    label="Provisão Mensal (%)"
                    placeholder="Provisão Mensal"
                    // required={true}
                    type="number"
                  /> */}
                </div>
                {simpleOrPresumed === "presumed" && (
                  <>
                    <div className="w-full flex mb-5">
                      <Input
                        value={taxData?.taxesDataItens?.workAccidentInsurance}
                        setValue={(e) => updateValue(e.target)}
                        name="workAccidentInsurance"
                        label="Seguro de acidente de trabalho - SAT (%)"
                        placeholder="Seguro de acidente de trabalho"
                        // required={true}
                        type="number"
                      />
                      <Input
                        value={taxData?.taxesDataItens?.holidayProportional}
                        setValue={(e) => updateValue(e.target)}
                        name="holidayProportional"
                        label="Proporcional de férias (%)"
                        placeholder="Proporcional de férias"
                        // required={true}
                        type="number"
                      />
                      <Input
                        value={taxData?.taxesDataItens?.weeklyPaidRest}
                        setValue={(e) => updateValue(e.target)}
                        name="weeklyPaidRest"
                        label="DSR (%)"
                        placeholder="Descanso semanal remunerado"
                        // required={true}
                        type="number"
                      />
                    </div>
                    <div className="w-full flex mb-5">
                      <Input
                        value={taxData?.taxesDataItens?.educationSalary}
                        setValue={(e) => updateValue(e.target)}
                        name="educationSalary"
                        label="Salário Educação (%)"
                        placeholder="Salário Educação"
                        // required={true}
                        type="number"
                      />
                      <Input
                        value={taxData?.taxesDataItens?.proportionalThirteenthSalary}
                        setValue={(e) => updateValue(e.target)}
                        name="proportionalThirteenthSalary"
                        label="Proporcional de 1/3 do 13º (%)"
                        placeholder="Proporcional de 1/3 do 13º"
                        // required={true}
                        type="number"
                      />
                      <InputSelect
                        name="system"
                        label={"Sistema Sebrae/Senai ou SESI"}
                        list={[
                          { value: 1, name: "Sebrae" },
                          { value: 2, name: "Senai" },
                          { value: 3, name: "Sesi" },
                        ]}
                        value={taxData?.taxesDataItens?.system}
                        onChange={(event: any) => updateValue({ name: event.target.name, value: +event.target.value })}
                        // required={true}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="justify-end gap-3">
              <Button onClick={exitForm} className="bg-secondary mt-11 flex items-center">
                Cancelar
              </Button>
              <Button className="bg-primary mt-11 flex items-center" type="submit">
                Salvar
              </Button>
            </div>
          </form>
        </div>
      </Spinner>
    </>
  );
}
